"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bed = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const bed = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'bed-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M16.7461 3.67332C16.7077 3.29513 16.3883 3 16 3H4C3.58579 3 3.25 3.33579 3.25 3.75V10.0137C2.12501 10.1381 1.25 11.0919 1.25 12.25V15.75C1.25 16.1642 1.58579 16.5 2 16.5H3V18C3 18.4142 3.33579 18.75 3.75 18.75C4.16421 18.75 4.5 18.4142 4.5 18V16.5H15.5V18C15.5 18.4142 15.8358 18.75 16.25 18.75C16.6642 18.75 17 18.4142 17 18V16.5H18C18.4142 16.5 18.75 16.1642 18.75 15.75V12.25C18.75 11.0919 17.875 10.1381 16.75 10.0137V3.75C16.75 3.72411 16.7487 3.69853 16.7461 3.67332ZM15.25 4.5L4.75 4.5V8.7815C4.82991 8.76094 4.91368 8.75 5 8.75H7.5C8.24325 8.75 8.86024 9.29057 8.97926 10H11.0207C11.1398 9.29057 11.7568 8.75 12.5 8.75H15C15.0863 8.75 15.1701 8.76094 15.25 8.78151V4.5ZM3.5 11.5H16.5C16.9142 11.5 17.25 11.8358 17.25 12.25V15H2.75V12.25C2.75 11.8358 3.08579 11.5 3.5 11.5Z', fill: '#4B5563' })));
};
exports.bed = bed;
